<template>
  <div
    class="chat-header-wrapper"
    :data-deployment-type="resolvedDeploymentType || 'unset'"
    :data-web-direct="resolvedDeploymentType === DeploymentType._WebDirect"
  >
    <HeaderSiddDuo
      v-if="resolvedDeploymentType === DeploymentType._SiddDuo"
      @back="handleBack"
      @source="handleSource"
    />

    <HeaderWebDirect
      v-else-if="resolvedDeploymentType === DeploymentType._WebDirect"
      @menu="handleMenu"
      @source="handleSource"
    />

    <HeaderPublicWidget
      v-else-if="resolvedDeploymentType === DeploymentType._PublicWidget"
      @close="handleClose"
      @minimize="handleMinimize"
      @source="handleSource"
    />

    <HeaderSiddStudio
      v-else-if="resolvedDeploymentType === DeploymentType._SiddStudio"
      @close="handleClose"
      @minimize="handleMinimize"
      @menu="handleMenu"
      @source="handleSource"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { DeploymentType } from '@/types'
import { useChatbot } from '@/composables/useChatbot'
import HeaderSiddDuo from './HeaderSiddDuo.vue'
import HeaderPublicWidget from './HeaderPublicWidget.vue'
import HeaderWebDirect from './HeaderWebDirect.vue'
import HeaderSiddStudio from './HeaderSiddStudio.vue'
import type { IChatHeaderProps, IChatHeaderEmits } from './types'

defineProps<IChatHeaderProps>()
const emit = defineEmits<IChatHeaderEmits>()

const chatbot = useChatbot()

const resolvedDeploymentType = computed(() => {
  return chatbot.store.configuration?.deploymentType
})

const handleClose = () => {
  emit('close')
}

const handleMinimize = () => {
  emit('minimize')
}

const handleBack = () => {
  emit('back')
}

const handleMenu = () => {
  emit('menu')
}

const handleSource = () => {
  emit('source')
}
</script>

<style>
.chat-header-wrapper {
  position: relative;
}

.chat-header-separator {
  background: hsl(var(--muted-foreground)) !important;
  height: 1px !important;
  width: 100% !important;
  display: block !important;
  opacity: 0.3 !important;
  transition: all 0.2s ease-in-out;
}

.sidd-chat-header {
  background: hsl(var(--background));
  border-bottom: 1px solid hsl(var(--border));
  padding: 8px 8px 8px 0 !important;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

.sidd-chat-header__content {
  display: flex;
  align-items: center;
}
</style>
